import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import ActivityExpando from "core/event/component/activityExpando";
import {GridParams} from "core/grid/domain/grid";
import {action} from "mobx";
import eventService from "core/event/eventService";
import {loc} from "core/common/config/locales";

const gridLocation = 'activityList';

@observer
export default class ActivityList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Activities`;
  static icon = 'volume-control-phone';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ActivityList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }


  @action bulkDelete = (gridParams: GridParams): Promise<any> => {
    return eventService.deletePartyActivity(gridParams);
  };

  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           showExpand ExpandComponent={ActivityExpando} multiDeleteSecurable={SECURABLE.activityList} multiDeleteSaveFn={this.bulkDelete} />
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/event/activityList.tsx